export const SET_AUDIT_ENTRIES = "SET_AUDIT_ENTRIES";
export const SET_VIEWING_AUDIT = "SET_VIEWING_AUDIT";
